import { connectRouter } from "connected-react-router";
import { AnyAction, combineReducers } from "redux";
import { FileDoc } from "../db/File";
import history from "./history";
import report from "./report";

const loading = (state = { status: false }, action: AnyAction) => {
  switch (action.type) {
    case "BEGIN_LOADING":
      return { status: true };
    case "END_LOADING":
      return { status: false };
    default:
      return state;
  }
};

const fileList = (state: FileDoc[] = [], action: AnyAction) => {
  switch (action.type) {
    case "UPDATE_FILE_LIST":
      return action.payload;
    default:
      return state;
  }
};

export default combineReducers({
  router: connectRouter(history),
  loading,
  fileList,
  report
});



// WEBPACK FOOTER //
// ./src/redux/reducers.ts